<div class="profile relative">
  <button
    type="button"
    [ngClass]="dropdownMenu.dropdownOpened ? 'bg-primary-light' : ''"
    class="primary-dark rounded-full border-2 border-primary-dark py-2 px-3 text-sm font-medium text-primary-darkest hover:bg-primary-dark"
    (click)="dropdownMenu.toggle($event)">
    <fa-icon [icon]="faUser"></fa-icon>
  </button>
  <fc-dropdown #dropdownMenu fcStyleClass="fc-dropdown right-0">
    <div
      class="grid min-w-[300px] rounded-md border-t bg-white py-3 shadow-xl"
      *ngIf="user">
      <div
        class="user-card m-2 flex items-center gap-3 rounded-lg px-3 py-2 shadow-md">
        <picture>
          <img
            class="h-10 w-10 flex-none rounded-full border border-primary-md-dark"
            [src]="
              user.propic_path
                ? user.propic_path
                : 'assets/images/default-user.png'
            "
            alt="user profile" />
        </picture>
        <div>
          <div class="text-sm font-bold text-primary-darkest">
            {{ user.name }}
          </div>
          <div class="flex items-center gap-x-2 hover:text-primary-darkest">
            <a class="text-xs text-primary-md-dark" routerLink="/user/profile"
              >Edit Profile</a
            ><span
              ><fa-icon
                class="fa-xs text-primary-md-dark"
                [icon]="faAngleRight"></fa-icon
            ></span>
          </div>
        </div>
      </div>
      <div class="happy-pay-card m-2 rounded-lg bg-primary-main py-2 px-3">
        <div class="flex items-center justify-between">
          <div>
            <div class="flex items-center space-x-1">
              <fa-icon
                class="fa-sm text-primary-md-dark"
                [icon]="faCreditCard"></fa-icon>
              <div class="text-sm font-bold text-primary-darkest">
                Happy Pay
              </div>
            </div>
            <div class="my-1 text-xs text-primary-darkest">
              Account: {{ user.happy_pay.account_no }}
            </div>
            <div class="text-xs font-bold text-primary-darkest">
              {{ user.happy_pay.current_balance | fcCurrency }}
            </div>
          </div>
          <button
            class="items-center rounded-md bg-primary-md-dark py-2 px-3 text-xs text-white hover:bg-primary-darkest">
            <span><fa-icon class="fa-md mr-1" [icon]="faPlus"></fa-icon></span
            >TOP UP
          </button>
        </div>
      </div>
      <div
        class="quicklink mx-2 cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-primary-darkest hover:bg-black/5"
        *ngFor="let link of quickLinks"
        (click)="dropdownMenu.hide(); link.action()">
        <fa-icon
          class="fa-md mr-2 text-primary-darkest"
          [icon]="link.icon"></fa-icon
        >{{ link.title }}
      </div>
    </div>
  </fc-dropdown>
</div>
